(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockVertragsunterlagen', {
            require: {
                form: '^form'
            },
            templateUrl: 'bloecke/dokumente/blockVertragsunterlagen.html',
            controller: BlockVertragsunterlagenController,
            controllerAs: 'vertragsunterlagenVm'
        });

    BlockVertragsunterlagenController.$inject = [
        'AngebotModel',
        'AngebotUtilsService',
        'BasisAngebotService'
    ];
    function BlockVertragsunterlagenController(AngebotModel, AngebotUtilsService, BasisAngebotService) {
        var vm = this;

        vm.isAngebotAenderbar = isAngebotAenderbar;
        vm.isBausteinAktiv = isBausteinAktiv;

        activate();

        function activate() {
            vm.angebotModel = AngebotModel.get();
            vm.pdfLinks = AngebotUtilsService.getPdfLinks(vm.angebotModel.angebot, vm.angebotModel.tarif.tarifkuerzel);
        }

        function isAngebotAenderbar(type) {
            return BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, type);
        }

        function isBausteinAktiv(obj, baustein) {
            return BasisAngebotService.isBausteinAktiv(obj, baustein);
        }
    }

})();
